import examActions from "./actions";

const initialState = {
  projectDetails : [],
  heartBeat : [],
  instructions : [],
  questionsAndOptions : [],
  submitAnswer : [],
};

const examReducer = (state = initialState, action) => {
  switch (action.type) {
    case examActions.SET_PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: action.payload,
      };
    case examActions.SET_HEART_BEAT:
      return {
        ...state,
        heartBeat: action.payload
      };
    case examActions.SET_INSTRUCTIONS:
      return {
      ...state,
      instructions: action.payload
    };
    case examActions.SET_EXAM_QUESTIONS:
      return {
        ...state,
        questionsAndOptions: action.payload
      };
    case examActions.SET_SUBMIT_ANSWER:
      return {
        ...state,
        submitAnswer : action.payload
      }  
    default:
      return state;
  }
}

export default examReducer;